var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "user-center-slot",
    [
      _c(
        "user-center-container-slot",
        [
          _c("user-center-menu"),
          _vm._v(" "),
          _c(
            "user-center-content-slot",
            [
              _c("user-center-content-title", { attrs: { title: "我的漏洞" } }),
              _vm._v(" "),
              _c("div", { staticClass: "user-center__vlun-row" }, [
                _c("div", [
                  _c("i", {
                    staticClass:
                      "iconfont icon-jinggao user-center__vlun-icon--default"
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-center__vlun-number" }, [
                  _vm._v(" 您有"),
                  _c(
                    "span",
                    {
                      staticClass: "user-center__vlun-number-txt",
                      attrs: { id: "msgNum" }
                    },
                    [_vm._v(" " + _vm._s(_vm.total))]
                  ),
                  _vm._v("个漏洞")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__msg-operation" },
                [
                  _c(
                    "xui-select",
                    {
                      staticClass: "user-center__msg-operation-item",
                      attrs: { placeholder: "ALL", clearable: "" },
                      on: { change: _vm.listStatus },
                      model: {
                        value: _vm.status,
                        callback: function($$v) {
                          _vm.status = $$v
                        },
                        expression: "status"
                      }
                    },
                    _vm._l(_vm.statusOption, function(item) {
                      return _c("xui-option", {
                        key: item.key,
                        staticClass: "item-dropdown",
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("xui-input", {
                    staticClass: "user-center__msg-operation-item",
                    attrs: {
                      "suffix-icon": "fa fa-search",
                      autocomplete: "off",
                      placeholder: "漏洞名称"
                    },
                    on: { blur: _vm.list },
                    model: {
                      value: _vm.vulTitle,
                      callback: function($$v) {
                        _vm.vulTitle =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "vulTitle"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__vlun-list" },
                [
                  _c(
                    "xui-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.latestData,
                        stripe: false,
                        border: "",
                        "show-header": true
                      }
                    },
                    [
                      _c("xui-table-column", {
                        attrs: {
                          prop: "creationDate",
                          label: "提交时间",
                          align: "left"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: {
                          prop: "vulTitle",
                          title: "vulTitle",
                          label: "漏洞名称"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "user-center__vlun-item-title"
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "user-center__vlun-list-link",
                                        attrs: {
                                          title: scope.row.vulTitle,
                                          href: "javascript:void(0);"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.toDetail(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(scope.row.vulTitle))]
                                    ),
                                    _vm._v(" "),
                                    scope.row && scope.row.leavingMsgCount > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "user-center__vlun-msg--unread"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.leavingMsgCount)
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        staticClass: "is-top",
                        attrs: {
                          prop: "displayStatusName",
                          "min-width": "70",
                          label: "状态"
                        }
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: { label: "漏洞等级" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      scope.row.vulLevel
                                        ? _vm.vulLevelOption[scope.row.vulLevel]
                                            .label
                                        : ""
                                    ) +
                                    "\n                "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("xui-table-column", {
                        attrs: { prop: "amount", label: "奖励金额" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "user-center__vlun-pager" },
                [
                  _c("xui-pagination", {
                    attrs: {
                      "current-page": _vm.currentPage,
                      "page-size": 5,
                      layout: "total, pager, jumper",
                      total: _vm.pageTotal
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.currentPage = $event
                      },
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "xui-dialog",
        {
          staticClass: "warnning-wrap",
          attrs: {
            title: "",
            "close-on-click-modal": false,
            showcenter: "",
            visible: _vm.dialogVisible,
            width: _vm.$store.state.isMobile ? "80%" : "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "h3",
            {
              style: {
                "font-size": _vm.$store.state.isMobile ? "24px" : "16.5px"
              }
            },
            [_vm._v("荣耀安全应急响应中心服务条款")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-wrap",
              style: {
                "font-size": _vm.$store.state.isMobile ? "22px" : "14px"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "欢迎您使用荣耀安全应急响应中心（Honor Security Response Center）服务，本平台在特定场景下需收集您的如下信息:"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [_vm._v("真实姓名，身份证正反面照片及身份证号；")]),
                _vm._v(" "),
                _c("li", [_vm._v("银行卡号，开户行信息，银行名称；")]),
                _vm._v(" "),
                _c("li", [_vm._v("手机号码，邮寄地址；")]),
                _vm._v(" "),
                _c("li", [_vm._v("昵称，头像，邮箱，主页；")]),
                _vm._v(" "),
                _c("li", [_vm._v("QQ，微信，签名，团队；")]),
                _vm._v(" "),
                _c("li", [_vm._v("IP地址；")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "为防止欺骗行为，荣耀需采集浏览器信息（类型、时区、插件、语言、字体、canvas图片渲染哈希值、webgl图片渲染哈希值）；"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "上述数据将会传输并保存至位于中华人民共和国境内的服务器。"
                )
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v("点击“同意”，即表示您同意\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-user-protocol",
                    attrs: { href: _vm.safetyURL, target: "_blank" }
                  },
                  [_vm._v("荣耀安全应急响应中心用户协议")]
                ),
                _vm._v("\n        ，并知悉\n        "),
                _c(
                  "a",
                  {
                    staticClass: "honor-security-secret-statement",
                    attrs: { href: _vm.privacyURL, target: "_blank" }
                  },
                  [_vm._v("关于安全应急响应中心与隐私的声明")]
                ),
                _vm._v("。")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer", center: "" }, slot: "footer" },
            [
              _c(
                "xui-button",
                { attrs: { size: "bigger" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "xui-button",
                {
                  attrs: { type: "primary", size: "bigger" },
                  on: { click: _vm.confirm }
                },
                [_vm._v("同意")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.isNotLogin && _vm.isEffect
        ? _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "失效提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("您的账号已经失效，请联系管理员")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v("返回首页")]
                  )
                ],
                1
              )
            ]
          )
        : _c(
            "xui-dialog",
            {
              staticClass: "login-dialog",
              attrs: {
                title: "登录提醒",
                "close-on-click-modal": false,
                showcenter: "",
                visible: _vm.isNotLogin,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.isNotLogin = $event
                },
                close: _vm.handleClose
              }
            },
            [
              _c("span", [_vm._v("系统检测到您未登录或登录失效，请先登录")]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer", center: "" },
                  slot: "footer"
                },
                [
                  _c(
                    "xui-button",
                    {
                      attrs: { type: "primary", size: "bigger" },
                      on: { click: _vm.login }
                    },
                    [_vm._v("荣耀账号登录")]
                  )
                ],
                1
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-131ccb3a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-131ccb3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/report/UsercenterReport.vue
// module id = null
// module chunks = 